<ng-template elderToolbarColumn="right.actions">
  <app-facility-context-menu></app-facility-context-menu>
</ng-template>
<elder-single-pane-wrapper>
  <elder-table
    class="flex"
    matSort
    [data]="data"
    [idField]="'id'"
    (itemClick)="openSideDetail($event)"
  >
    <elder-data-toolbar
      *elderTableToolbar
      (requestNew)="create()"
      [canRemove]="false"
      [canAdd]="true"
      [canMore]="false"
    >
      <ng-template elderToolbarContent="center">
        <elder-search-box
          dense
          class="flex-60 pt-xs"
          queryKey="query"
          [autoPanel]="false"
          [elderSearchContext]="data.filter"
          [forcedFilters]="extractFilters(forcedFiltersByKey$ | async)"
        >
          <!-- Advanced search -->
          <elder-search-panel class="layout-col p-sm">
            <div class="layout-row place-start-center gap-sm">
              <mat-form-field>
                <input
                  matInput
                  name="ownedBy"
                  ngModel
                  placeholder="{{ 'orders.ownedBy' | translate }}"
                  elderSearchInput
                />
              </mat-form-field>

              <mat-form-field>
                <input
                  matInput
                  name="validatedBy"
                  ngModel
                  placeholder="{{ 'orders.validatedBy' | translate }}"
                  elderSearchInput
                />
              </mat-form-field>
            </div>

            <div class="layout-row place-start-center gap-sm"></div>

            <div class="layout-row place-start-center gap-sm"></div>
          </elder-search-panel>
        </elder-search-box>
      </ng-template>
    </elder-data-toolbar>

    <!-- icon -->
    <ng-container matColumnDef="icon">
      <th mat-header-cell *matHeaderCellDef style="width: 30px"></th>
      <td mat-cell *matCellDef="let row">
        <mat-icon>control_camera</mat-icon>
      </td>
    </ng-container>

    <!-- number Column -->
    <ng-container matColumnDef="number">
      <th mat-header-cell *matHeaderCellDef style="width: 10%" mat-sort-header>
        {{ 'context.number' | translate }}
      </th>
      <td mat-cell *matCellDef="let cc">{{ cc.number }}</td>
    </ng-container>

    <!-- name Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef style="width: 10%" mat-sort-header>
        {{ 'context.name' | translate }}
      </th>
      <td mat-cell *matCellDef="let cc">{{ cc.name }}</td>
    </ng-container>

    <!-- description Column -->
    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef style="width: 15%" mat-sort-header>
        {{ 'context.description' | translate }}
      </th>
      <td mat-cell *matCellDef="let cc">
        <div class="layout-col place-center-start">
          <span class="mat-body-2">{{ cc.description }}</span>
        </div>
      </td>
    </ng-container>

    @switch (typeMode) {
      @case (ControlCenterType.WORK_STATION) {
        <!-- workstations Column -->
        <ng-container matColumnDef="workstations">
          <th mat-header-cell *matHeaderCellDef style="width: 10%" mat-sort-header>
            {{ 'shopfloor.workstations.title' | translate }}
          </th>
          <td mat-cell *matCellDef="let cc">
            <app-work-stations-indicator [workStationIds]="cc.workStations">
            </app-work-stations-indicator>
          </td>
        </ng-container>
      }
      @case (ControlCenterType.STORAGE) {
        <!-- storageScope Column -->
        <ng-container matColumnDef="workstations">
          <th mat-header-cell *matHeaderCellDef style="width: 10%" mat-sort-header>
            {{ 'StorageScope' | translate }}
          </th>
          <td mat-cell *matCellDef="let cc">{{ cc.storage.storageScope }}</td>
        </ng-container>
      }
    }

    <!-- facility Column -->
    <ng-container matColumnDef="facility">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'context.facility' | translate }}
      </th>
      <td mat-cell *matCellDef="let cc">{{ cc.facility }}</td>
    </ng-container>

    <!-- type Column -->
    @if (!typeMode) {
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'context.type' | translate }}
        </th>
        <td mat-cell *matCellDef="let cc">
          {{ 'shopfloor.controlcenters.type.' + cc.type | translate }}
        </td>
      </ng-container>
    }

    <!-- createdAt -->
    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef style="width: 10%" mat-sort-header>
        {{ 'context.createdAt' | translate }}
      </th>
      <td mat-cell *matCellDef="let cc">
        {{ cc.createdAt | date: 'short' }}
      </td>
    </ng-container>
  </elder-table>
</elder-single-pane-wrapper>
